<template>
  <div class="spinner-container">
    <div class="fll-spinner" />
  </div>
</template>

<script>
export default {
  name: "Spinner",
};
</script>

<style lang="scss" scoped>
.spinner-container {
  display: flex;
  justify-content: center;

  .fll-spinner {
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;
  }
  .fll-spinner:after {
    content: " ";
    display: block;
    border-radius: 50%;
    width: 0;
    height: 0;
    margin: 6px;
    box-sizing: border-box;
    border: 26px solid $green;
    border-color: $green transparent $blue transparent;
    animation: fll-spinner 1.2s infinite;
  }
}

@keyframes fll-spinner {
  0% {
    transform: rotate(0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  50% {
    transform: rotate(900deg);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  100% {
    transform: rotate(1800deg);
  }
}
</style>
